
export default {
  name: 'icon-time',
};
